module.exports = __webpack_public_path__ + "static/media/shake.3d0fac06.png";